<template>
  <div>
    <el-alert
      v-if="sForm.ad_status === 3"
      style="margin-bottom: 10px;"
      :title="errorTip"
      type="error">
    </el-alert>
    <div class="m_context plr">
      <el-row>
        <el-col :span="24">
          <el-form label-width="12.5%" >
            <input type="hidden" v-model="sForm.ad_id"/>
            <el-form-item :label="$t('advert.name')" prop="ad_title">
              <!--<el-input v-model="sForm.ad_title"></el-input>-->
              <span class="grey_color">{{sForm.ad_title}}</span>
            </el-form-item>
            <el-form-item :label="$t('advert.classify')">
              <span class="grey_color" v-for="item,index in adTypeList" v-if="item.adtypeId == sForm.ad_type">{{item.adtypeName}}</span>
            </el-form-item>

            <el-form-item :label="$t('advert.position')">
              <span class="grey_color" v-if="sForm.ad_position == 0">{{$t('advert.positionSub.banner')}}</span>
              <span class="grey_color" v-if="sForm.ad_position == 1">{{$t('advert.positionSub.starPage')}}</span>
              <span class="grey_color" v-if="sForm.ad_position == 3">{{$t('app_appadv')}}</span>
              <!--<span class="grey_color" v-if="sForm.ad_position == 2">个人中心banner</span>-->
            </el-form-item>

            <!-- =========-->
            <!-- 跳转类型-->
            <!-- =========-->
            <el-form-item :label="$t('advert.jumpType')">
              <span class="grey_color" v-if="sForm.ad_Urltype == '0'">{{$t('advert.jumpTypeSub.net')}}</span>
              <span class="grey_color" v-if="sForm.ad_Urltype == '1'">{{$t('advert.jumpTypeSub.appStore')}}</span>
            </el-form-item>


            <!-- 当跳转类型为应用市场时,ad_url 则为下拉框选择应用对应的url -->
            <el-form-item v-if="sForm.ad_Urltype === '1'" :label="$t('advert.app')" prop="ad_url">
              <span class="grey_color" >{{appName}}</span>
            </el-form-item>

            <!-- 当跳转类型为跳转时,ad_url则输入跳转的url -->
            <el-form-item v-if="sForm.ad_Urltype === '0'" :label="$t('advert.url')" prop="ad_url">
              <span class="grey_color" >{{sForm.ad_url}}</span>
            </el-form-item>
            <!-- =========-->
            <!-- 跳转类型 end-->
            <!-- =========-->

            <el-form-item :label="$t('advert.channel')" prop="ad_channel">
              <span class="grey_color" >{{sForm.ad_channel_name}}</span>
            </el-form-item>

            <el-form-item :label="$t('advert.ableDate')">
              <el-col :span="7">
                <span class="grey_color">{{dateFormat2(sForm.ad_start_date)}}</span>
              </el-col>
              <el-col class="line" :span="2">&nbsp;-&nbsp;</el-col>
              <el-col :span="15">
                <span class="grey_color">{{dateFormat2(sForm.ad_start_end)}}</span>
              </el-col>
            </el-form-item>

            <el-form-item v-if="sForm.ad_id && sForm.ad_imgUrl" :label="$t('advert.contentImg')">
              <el-col :span="24">
                <img :src="imageUrl +sForm.ad_imgUrl" width="100%"/>
              </el-col>
            </el-form-item>

            <el-form-item>
              <el-button @click="cancelEdit">{{$t('mao_global.btn.cancel')}}</el-button>
              <!--<el-button v-if="sForm.ad_id === '0'" type="success" @click="createAdvert">添加</el-button>-->
              <!--<template v-else>-->
                <el-button v-if="sForm.ad_status == 0 || sForm.ad_status == 3" type="primary" @click="jumpToUpdate">{{$t('mao_global.btn.update')}}</el-button>
              <!--</template>-->
              

            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

    </div>
  </div>
</template>
<style scoped>
  .grey_color {
    color:grey;
  }
</style>
<script>
  import axios from 'axios'
  import mm from 'moment'
  import { baseurl,url } from '../../api/url'
  import VueCoreImageUpload from 'vue-core-image-upload'
  export default{
    components: {
      'vue-core-image-upload': VueCoreImageUpload,
    },
    data(){
      return {
        // 如果审核不通过,提示的信息
        errorTip: '',
        // 根据广告的类型, 动态改变裁剪的比例
        ratio: '24:1',
      	imageUrl: url,
        choiceAppVisible: false,
      	// 判断广告详情中的图片,是否新增或编辑状态
      	isCreateType: true,
        temPreview: null,
        editRules: {
          ad_title:[
            { required: true, message: this.$t('app_adnamenotnull'), trigger:'blur'}
          ],
          ad_url:[
            { required: true, message: this.$t('mao_global.tip.notBlank'), trigger:'blur'}
          ],
          ad_channel:[
            { required: true, message: this.$t('app_plslchannel'), trigger:'blur'}
          ]
        },
        // 渠道商列表
        channelList: '',
        tmp_appName: '',
        appName: '',
        appList: null,
        adTypeList: null,
        sForm: {
        	ad_id: this.$route.params.id,
          ad_imgUrl: null,
          ad_title: null, // 广告标题
          ad_type: '', // 广告类型
          ad_url: null, // 跳转链接
          ad_Urltype: '0',
          ad_start_date: null, // 开始时间
          ad_start_end: null, // 结束时间
          ad_content: null, // 广告内容
          ad_position: '0', // 广告位置: 0 首页banner 1 启动界面 2个人中心
          ad_playTimes: '', // 播放时长
          ad_channel: ''
        }
      }
    },
    computed: {
      imgUploadUrl () {
        return this.$imgUploadUrl
      }
    },
    mounted(){
    	var that = this
      that.fetchChannel()
      that.fetchData()
    },
    methods:{
    	jumpToUpdate () {
    		var that = this
        that.$router.push({path: '/advert-list/edit/' + that.sForm.ad_id})
      },
      imageuploaded (res) {
        if (res.status !== 200) {
          this.$message.error(res.message)
        } else {
          this.sForm.ad_imgUrl = res.data
        }
      },
      choiceAppRecord (v) {
        var that = this

        setTimeout(function(){
          that.appName = v['appName']
          that.sForm.ad_url = v['applicationid']

          that.choiceAppVisible = false
        }, 300)
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD')
      },
      getAppListByName () {
      	var that = this
        that.getAppList(that.tmp_appName)
      },
    	getAppList (name) {
    		var that = this

        var aName = ''
        if (name && name !== '') aName = name

        // 查询已经通过的app列表信息
        axios.post(`${baseurl}/app/list.do`,{'page':1, rows: 15, appName: aName ,appCategoryId:'',appStatus: '2'}).then(res=>{
          that.appList = res.data.data
        })
      },
      dateFormat2 (date) {
        return mm(date).format('YYYY-MM-DD')
      },
      cancelEdit () {
      	var that = this
        that.$router.push({path: "/advert-list"})
      },
      // 获取渠道商列表
      fetchChannel () {
      	var that = this
        axios.post(`${baseurl}/mechanism/list.do`,{'page':1, rows: 10000}).then(res=>{
          that.channelList = res.data.data
        })
      },
      // 查询数据
      fetchData () {
      	var that = this

        if (that.sForm.ad_id === '0') {
      		that.isCreateType = false
        } else {
          axios.post(`${baseurl}/advertisement/detail.do`,{'id':that.sForm.ad_id}).then(res=>{
            var obj = res.data.data;
            console.log(JSON.stringify(obj,null,2))
            that.sForm = {
              ad_id: obj['adId'],
              ad_imgUrl: obj['adImgurl'],
              ad_status: obj['adStatus'],
              ad_title: obj['adTitle'], // 广告标题
              ad_type: obj['adType'], // 广告类型
              ad_url: obj['adUrl'], // 跳转链接
              ad_Urltype: obj['adUrltype'],
              ad_start_date: obj['adStartDate'], // 开始时间
              ad_start_end: obj['adStartEnd'], // 结束时间
              ad_content: obj['adContent'], // 广告内容
              ad_position: obj['adPosition'], // 广告位置: 0 首页banner 1 启动界面 2个人中心
              ad_playTimes: obj['adPlayTimes']|| '', // 播放时长
              ad_channel: (obj['pMechanism']) ? obj['pMechanism']['mechanismid'] : '', // 渠道商
              ad_channel_name: (obj['pMechanism']) ? obj['pMechanism']['mechanismname'] : '' // 渠道商
            }

            if (obj['reFuseReason']) {
              that.errorTip = this.$t('mao_global.tip.notPassExamine') + ":" + obj['reFuseReason']
            }


            if (that.sForm.ad_Urltype == '1') {
              var appData = {
                  appName: obj.appName,
//                  applicationid: obj.application.applicationid
              }

              that.choiceAppRecord(appData)
            }

          })
        } // end if

        axios.post(`${baseurl}/adType/list.do`,{'page':1, rows: 10000}).then(res=>{
          that.adTypeList = res.data.data
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// detail.vue?db0b9ad4